/**
 * Exportar una lista a CSV, en el navegador.
 *
 * ── Por qué aquí y no en el servidor ────────────────────────────────────────
 * Lo que se exporta es LO QUE SE ESTÁ VIENDO: el buscador, los filtros y el
 * orden ya están aplicados en la pantalla, y quien pulsa «exportar» quiere esa
 * selección y no la tabla entera. Pedirla otra vez al servidor obligaría a
 * repetir allí cada filtro de cada lista.
 *
 * ── Los tres detalles que lo hacen abrir bien ───────────────────────────────
 * - Cada celda entre comillas y las comillas duplicadas: una coma, un salto de
 *   línea o una comilla dentro de una nota corren las columnas del resto.
 * - El BOM al principio: es lo que hace que Excel lea los acentos en vez de
 *   sacar «JosÃ©».
 * - `\r\n` entre filas, que es lo que dice el RFC del formato y lo que esperan
 *   Excel y Numbers en Windows.
 *
 * Los importes van en unidades y sin símbolo (`1234.5`), en una columna, y la
 * moneda en la suya: una hoja de cálculo suma números, no «$1,234.50».
 */

/** Lo que puede ir en una celda. Nada de objetos: una hoja no los lee. */
export type CsvValue = string | number | null | undefined

function cell(value: CsvValue): string {
  if (value === null || value === undefined) return '""'
  return `"${String(value).replace(/"/g, '""')}"`
}

/** Un importe en unidades, listo para sumar en una hoja. Sin separador de miles. */
export function csvAmount(minorUnits: number, factor: number): string {
  return factor === 1 ? String(minorUnits) : (minorUnits / factor).toFixed(2)
}

/**
 * El archivo entero, como texto. Aparte de la descarga para poder probarlo.
 */
export function csvText(columns: string[], rows: CsvValue[][]): string {
  const body = [columns, ...rows].map((row) => row.map(cell).join(',')).join('\r\n')
  return `\uFEFF${body}`
}

/**
 * Arma el CSV y lo descarga.
 *
 * `filename` sin extensión: se añade `.csv` con la fecha, para que dos
 * descargas del mismo día no se sobrescriban en la carpeta de descargas.
 */
export function downloadCsv(filename: string, columns: string[], rows: CsvValue[][]): void {
  const blob = new Blob([csvText(columns, rows)], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = `${filename}-${new Date().toISOString().slice(0, 10)}.csv`
  anchor.click()
  URL.revokeObjectURL(url)
}
